"use client";

import { useState } from "react";
import Link from "next/link";
import Image from "next/image";

import { getMedia } from "@/services/media";

//import { logError } from "@/lib/sentryLogger";

import { Mail, Globe, Phone } from "lucide-react";
import { MixpanelTracking } from "@/lib/mixpanel-browser-analytics";


interface VideoProps {
	video: any;
	href: string;
	business?: {
		email: string;
		website: string;
		phone: string;
	};
	likes?: number;
	dislikes?: number;
	
}


export default function VideoItem({ video, href, business, likes, dislikes }: VideoProps){

    const [showPreview, setShowPreview] = useState<boolean>(false);

	
    let thumbnailSrc = "/images/single-video.png";
	if (video?.thumbnail != undefined && video?.thumbnail !== "") {
		thumbnailSrc = getMedia(video?.thumbnail);
	}

    const handleMouseEnter = (e :any) => {
		setShowPreview(true);
		const vid = e.target;
		var isPlaying =
			vid.currentTime > 0 &&
			!vid.paused &&
			!vid.ended &&
			vid.readyState > vid.HAVE_CURRENT_DATA;

		if (!isPlaying) {
			vid.play();
			MixpanelTracking.getInstance().videoHoverPreviewPlayed({video_id: video?.id ?? '', vidoe_title: video?.title ?? ''});
		}
	};

    const handleMouseLeave = (e : any) => {
		setShowPreview(false);
		const vid = e.target;
		var thePromise = vid.play();
		if (thePromise != undefined) {
			thePromise.then(function (_ : any) {
				vid.pause();
				vid.currentTime = 0;
				//*MixpanelTracking.getInstance().videoPaused({video_id: video?.id ?? '', vidoe_title: video?.title ?? ''});
			});
		}
	};

    const handleVideoError = (e : any) => {
		e.target.addEventListener("error", (event : any) => {
			let error = event;
			
			//logError("VideoItemError", error);
		});
	};

    const hideExt = (name: string) => {
		return name?.substring(0, name?.lastIndexOf(".")) || name;
	};

	const videoItemClicked=(props?: {action?: string, other_props?: {}})=>{
		const result_category = (business == undefined) ? 'Skills Video' : 'Product & Business Video';
		MixpanelTracking.getInstance().interestSearchResultClickAction({
			action: props?.action ?? "Search result video item clicked", searcher_user_id: '', result_item_owner_id: '',
			other_props: {video_id: video?.id, video_title: video?.title, ...props?.other_props ?? {}},
		}, result_category);
		MixpanelTracking.getInstance().videoClicked({
			action: `${result_category} item clicked`,
			video_id: video?.id ?? '', video_title: video?.title ?? '',
		});
	}

	const cardItemLinkClicked=(target: string)=>{
		const category = (business == undefined) ? 'Skills Video' : 'Product & Business Video';
		MixpanelTracking.getInstance().linkClicked(
			`${target} link of ${category} search result item clicked`
		);
	}

    return(
        
        <div className="rounded-sm bg-slate-100 w-full max-w-[320px] flex flex-col flex-wrap break-words ">
			<div className="group">
			
				<Link href={href} onClick={()=>videoItemClicked()}> 
					<div className="relative self-center sm:self-start">
						<video
							muted
							loop
							poster={thumbnailSrc}
							onMouseEnter={handleMouseEnter}
							onMouseLeave={handleMouseLeave}
							className="admin-video-card aspect-video w-full max-w-[320px] h-[219px] rounded-t-md"
						>
							
							<source
								src={video.preview && video.preview !== "" ? getMedia(video.preview) : getMedia(video?.location)}
								type="video/mp4"
								onError={handleVideoError}
								
							/>
						</video>
						{!showPreview && (
							<Image className="absolute w-[30px] h-auto opacity-80 top-[calc(50%_-_15px)] left-[calc(50%_-_15px)]" src="/images/play-icon.png" alt="" width={30} height={30}/>
						)}
					</div>
				</Link>

				<div className="p-3">
					<Link href={href} onClick={()=>videoItemClicked()}>
						<div className="font-medium text-xl hover:text-blue-500 group-hover:text-blue-500">{hideExt(video.title)}</div>
						<div className="description">
							{video?.watchCount || "0"} views
						</div>
						{video?.tags && (
							<div className="flex flex-wrap gap-2 mt-6">
								{video?.tags.slice(0, 3).map(
									(tag: string) =>
										!tag.includes(" ") &&
										tag.length < 12 && (
											<div key={tag} className="text-slate-600 bg-slate-200 rounded-lg py-1 px-3 group-hover:bg-slate-300"
											onClick={()=>videoItemClicked({action: 'Video tag of search result item clicked', other_props: {tag_clicked: tag}})}>
												{tag}
											</div>
										)
								)}
							</div>
						)}
					</Link>
				</div>

			</div>

			{business && (
				<div className="p-4 mt-auto flex flex-wrap justify-between">

					{business.email && business.email != "" && (

						<a
						href={`mailto:${business?.email}`} onClick={()=> cardItemLinkClicked("Mail-To")}>
							<Mail className="text-blue-500 hover:text-green-500"/>
						</a>
						
					)}
					

					{business.website && business.website != "" && (

						<a href={business?.website} onClick={()=>cardItemLinkClicked("Busniness Website")}>
							<Globe className="text-blue-500 hover:text-green-500"/>
						</a>
						
					)}

					{business.phone && business.phone != "" && (
						
						<a href={`tel:${business?.phone}`} onClick={()=>cardItemLinkClicked("Business Phone")}>
							<Phone fill="currentColor" className="text-blue-500 hover:text-green-500"/>
						</a>

					)}
					
					
				</div>
			)}
		</div>
    )
}



